// extracted by mini-css-extract-plugin
export default {"container":"Tq-z","heading":"Uq-z","text":"Vq-z","info":"Wq-z","link":"Xq-z","fullMaxWidth":"Yq-z"};